
import React, { useEffect, useState } from "react";
import { HiOutlineScale } from "react-icons/hi2";
import { media } from "../../server";

export function getServiceImageUrl(image) {
  if (!image || typeof image !== "string") {
    return null;
  }

  const path = image.trim();

  if (!path) return null;

  if (/^(https?:\/\/|data:image\/|blob:)/i.test(path)) {
    return path;
  }

  const base = String(media || "").replace(/\/+$/, "");
  const cleanPath = path.replace(/^\/+/, "");

  return base
    ? `${base}/${cleanPath}`
    : `/${cleanPath}`;
}

function ServiceImage({
  image,
  alt = "",
  className = "",
  priority = false,
}) {
  const [hasError, setHasError] = useState(false);
  const imageUrl = getServiceImageUrl(image);

  useEffect(() => {
    setHasError(false);
  }, [imageUrl]);

  return (
    <div
      className={`
        relative isolate
        overflow-hidden
        bg-[#142C40]
        ${className}
      `}
    >
      {imageUrl && !hasError ? (
        <img
          src={imageUrl}
          alt={alt}
          loading={priority ? "eager" : "lazy"}
          decoding="async"
          onError={() => setHasError(true)}
          className="
            absolute inset-0
            h-full w-full
            object-cover object-center
            transition-transform duration-700
            group-hover:scale-[1.035]
          "
        />
      ) : (
        <div
          className="
            absolute inset-0
            flex items-center justify-center
            bg-gradient-to-br
            from-[#294961]
            via-[#18354A]
            to-[#0B1726]
          "
        >
          <div
            aria-hidden="true"
            className="
              absolute -end-20 -top-24
              h-72 w-72 rounded-full
              border border-white/10
            "
          />

          <div
            aria-hidden="true"
            className="
              absolute -start-24 -bottom-24
              h-64 w-64 rounded-full
              border border-white/10
            "
          />

          <HiOutlineScale
            size={82}
            aria-hidden="true"
            className="text-[#D7B77F]/65"
          />
        </div>
      )}
    </div>
  );
}

export default ServiceImage;
